var render = function render(){var _vm=this,_c=_vm._self._c;return _c('countdown',{attrs:{"time":_vm.time,"interval":1000,"transform":_vm.transform},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('Counter',{attrs:{"title":_vm.title,"data":_vm.getCounterData(props)}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }